import moment from 'moment';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import Autocomplete from 'react-google-autocomplete';

import * as AppConst from '../../constants/App';
import * as RoutePaths from '../../constants/RoutePaths';
import {
    setDateEnd,
    setAddress,
    setPlaceId,
    setDateStart,
    setTypeApartments,
    setMapDataFromPlaceAutoComplete
} from '../../actions/Search';

const defaultProps = {
    setAddress: address => {
    },
    setPlaceId: placeId => {
    },
    setTypeApartments: name => {
    },
    setDateEnd: dateEndMoment => {
    },
    setDateStart: dateStartMoment => {
    }
};

class FilterSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRent: true,
            typeApartment: '',
            isTypeApartmentsVisible: false,
            searchType: RoutePaths.SEARCH_TYPE_RENTAL
        };
    }

    handleTypeChange() {
        this.setState(prevState => {
            const newState = {
                isRent: !prevState.isRent,
                searchType: !prevState.isRent ? RoutePaths.SEARCH_TYPE_RENTAL : RoutePaths.SEARCH_TYPE_BUY
            };

            if (!newState.isRent) {
                newState.dateStart = undefined;
                newState.dateStartString = undefined;
                newState.dateEnd = undefined;
                newState.dateEndString = undefined;
            }
            return newState;
        });
    }

    handleAddressChange(place) {
        this.props.setMapDataFromPlaceAutoComplete(place);

        this.setState({
            address: place.formatted_address
        });
    }

    handleDateStartChange(date) {
        if (!date.isBefore(moment().subtract(1, 'days'))) {
            this.props.setDateStart(date);

            this.setState({
                dateStart: date,
                dateStartString: date.format(AppConst.DATE_FORMAT)
            });
        }
    }

    handleDateEndChange(date) {
        if (!date.isBefore(moment().subtract(1, 'days'))) {
            this.props.setDateEnd(date);

            this.setState({
                dateEnd: date,
                dateEndString: date.format(AppConst.DATE_FORMAT)
            });
        }
    }

    handleTypeApartmentCheck = value => {
        this.props.setTypeApartments(value);

        if (this.state.isRent) {
            this.setState({
                isRent: false,
                dateEnd: undefined,
                dateStart: undefined,
                dateEndString: undefined,
                dateStartString: undefined,
                searchType: RoutePaths.SEARCH_TYPE_BUY
            });
        }
    };

    handleDeleteTypeApartmentClick = value => {
        this.props.setTypeApartments(value);
    };

    setIsTypeApartmentsVisible = isVisible => {
        this.setState({
            isTypeApartmentsVisible: isVisible
        });
    };

    render() {
        const {isTypeApartmentsVisible} = this.state;
        const {i18n, code, typeApartments, configTypeApartmentsSell} = this.props;

        return (
            <div className="filter-section">
                <div className="wide1570">
                    <form>
                        <div className="search-type">
                            <label className="checkbox">
                                <input
                                    name="rental"
                                    type="checkbox"
                                    checked={this.state.isRent}
                                    onChange={::this.handleTypeChange} />
                                <span>{i18n['layout.rent']}</span>
                            </label>
                            <div className="drop-wrapper" onMouseLeave={() => this.setIsTypeApartmentsVisible(false)}>
                                <label
                                    className="checkbox drop_var_buy"
                                    onClick={() => this.setIsTypeApartmentsVisible(true)}
                                    onMouseOver={() => this.setIsTypeApartmentsVisible(true)}
                                >
                                    <input
                                        name="buy"
                                        type="checkbox"
                                        checked={!this.state.isRent}
                                        onChange={::this.handleTypeChange} />
                                    <span>{i18n['layout.buy']}</span>
                                </label>
                                <div className="delete-tag">
                                    <div className="delete-tags">
                                        {typeApartments.map(elem => (
                                            <div
                                                key={elem}
                                                className="delete-tag-enter"
                                                onClick={() => this.handleDeleteTypeApartmentClick(elem)}
                                            >
                                                {configTypeApartmentsSell.find(
                                                    configElem => configElem.value === elem
                                                ).title}
                                            </div>
                                        ))}
                                    </div>
                                    {isTypeApartmentsVisible && <div className="delete-tag_select">
                                        {configTypeApartmentsSell.map(elem => (
                                            <span
                                                key={elem.value}
                                                onClick={() => this.handleTypeApartmentCheck(elem.value)}
                                                className={typeApartments.includes(elem.value) ? 'checked' : ''}
                                            >
                                                {elem.title}
                                            </span>
                                        ))}
                                    </div>}
                                </div>
                            </div>

                        </div>
                        <div className="search-inputs">
                            <label className="main-search">
                                {this.props.configuration.isGoogleApiInit && <Autocomplete
                                    className="text-field"
                                    placeholder={i18n['layout.autocompletePlaceholder']}
                                    types={[]}
                                    onPlaceSelected={place => {
                                        ::this.handleAddressChange(place);
                                    }}
                                />}
                            </label>
                            <div className="to-date">
                                {code !== undefined && <DatePicker
                                    locale={code}
                                    className="text-field"
                                    disabled={!this.state.isRent}
                                    selected={this.state.dateStart}
                                    dateFormat={AppConst.DATE_FORMAT}
                                    onChange={::this.handleDateStartChange}
                                    calendarClassName="promo-content_datepicker date-start"
                                    placeholderText={i18n['layout.dateStartPlaceholder']}
                                    dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                        'react-datepicker__day--disabled' :
                                        date.isSame(this.state.dateStart) ?
                                            'selecting-range-start' :
                                            undefined}
                                />}
                            </div>
                            <div className="from-date">
                                {code !== undefined && <DatePicker
                                    locale={code}
                                    className="text-field"
                                    disabled={!this.state.isRent}
                                    selected={this.state.dateEnd}
                                    dateFormat={AppConst.DATE_FORMAT}
                                    onChange={::this.handleDateEndChange}
                                    calendarClassName="promo-content_datepicker date-end"
                                    placeholderText={i18n['layout.dateEndPlaceholder']}
                                    dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                        'react-datepicker__day--disabled' :
                                        date.isSame(this.state.dateEnd) ?
                                            'selecting-range-start' :
                                            undefined}
                                />}
                            </div>
                            <Link className="btn" to={{
                                pathname: RoutePaths.SEARCH,
                                search: this.state.searchType
                            }}>{i18n['layout.findButton']}</Link>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

FilterSection.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    configuration: state.configuration,
    code: state.languages.currentLanguage.code,
    typeApartments: state.searchPage.requestParams.typeApartments,
    configTypeApartmentsSell: state.configuration.object.typeApartmentsSell
});

const mapDispatchToProps = {
    setDateEnd,
    setAddress,
    setPlaceId,
    setDateStart,
    setTypeApartments,
    setMapDataFromPlaceAutoComplete
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);



// WEBPACK FOOTER //
// ./src/components/Base/FilterSection.js